
/**
 * @provides OCS.UniqueIdGen
 * @type Class
 */

var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.UniqueIdGen = new Class({
    Implements: [Options, new Class(OCS.Interfaces.UniqueId)],
    class_type: "UniqueIdGen",
    class_name: "UniqueIdGen",    
    options: {/*
        unique_id_base_string: 'xxxxxxxx_xxxx_4xxx_yxxx_xxxxxxxxxxxx',
        unique_id_prepend_string: ''
 */
    },
    initialize: function (op) {
        this.setOptions(op);
    },

});


